var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dealers && _vm.dealers.length > 0)?_c('div',[_vm._l((_vm.dealers),function(dealer){return _c('div',{key:dealer.documentId},[_c('DealerDesktop',{attrs:{"dealer":dealer}})],1)}),_vm._v(" "),_c('BackToTopButton')],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }